module.exports = __webpack_public_path__ + "img/Icon - Fire.492b3658.png";